import React from 'react';
import { FormattedMessage } from 'react-intl';

const AuthorizedUserListHeader = () =>
    (<div className='widget-header'>
        <FormattedMessage id='reporting.authorizedUserList.header'/>
    </div>);

export default AuthorizedUserListHeader;
